import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach token if stored (fallback to cookie)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("lf_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const STATUSES = [
  { key: "new_lead", label: "New Lead", color: "bg-blue-100 text-blue-800 border-blue-200" },
  { key: "contacted", label: "Contacted", color: "bg-amber-100 text-amber-800 border-amber-200" },
  { key: "quote_sent", label: "Quote Sent", color: "bg-indigo-100 text-indigo-800 border-indigo-200" },
  { key: "follow_up", label: "Follow-Up", color: "bg-orange-100 text-orange-800 border-orange-200" },
  { key: "booked", label: "Booked", color: "bg-emerald-100 text-emerald-800 border-emerald-200" },
  { key: "completed", label: "Completed", color: "bg-zinc-200 text-zinc-800 border-zinc-300" },
  { key: "lost", label: "Lost", color: "bg-rose-100 text-rose-800 border-rose-200" },
];

export const statusMeta = (key) => STATUSES.find((s) => s.key === key) || STATUSES[0];
